
<template>
  <v-dialog
    :value="value"
    :persistent="loading || persistent"
    :max-width="maxWidth"
  >
    <v-card>
      <v-card-title class="headline">
        {{ title }}
      </v-card-title>
      <v-card-text>
        <slot name="subtitle">
          <div
            v-if="subtitle"
          >
            {{ subtitle }}
          </div>
        </slot>
        <div
          v-if="icon"
          class="d-flex justify-center"
        >
          <v-icon
            :size="100"
            color="primary"
            class="my-8"
          >
            {{ icon }}
          </v-icon>
        </div>
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn
          :disabled="loading"
          text
          color="green darken-1"
          @click="close()"
        >
          {{ cancelText }}
        </v-btn>
        <v-btn
          :loading="loading"
          color="warning darken-1"
          text
          @click="$emit('confirm')"
        >
          {{ confirmText }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
  export default {
    name: 'ConfirmDialog',
    props: {
      value: Boolean,
      title: String,
      subtitle: {
        type: String,
        default: null,
      },
      icon: {
        type: String,
        default: null,
      },
      confirmText: {
        type: String,
        default: 'Подтвердить',
      },
      cancelText: {
        type: String,
        default: 'Отмена',
      },
      maxWidth: {
        type: String,
        default: '500px',
      },
      loading: {
        type: Boolean,
        default: false,
      },
      persistent: {
        type: Boolean,
        default: false,
      },
    },
    methods: {
      close () {
        this.$emit('input', false)
        this.$emit('close')
      },
    },
  }
</script>
